<template>
  <div class="card">
    <div>
      <slot name="header"></slot>
    </div>
    <div>
      <slot name="body" v-if="props.loaded"></slot>
      <Loader v-else></Loader>
    </div>
    <div>
      <slot name="footer"></slot>
    </div>
  </div>
</template>

<script setup lang="ts">
import Loader from "./Loader.vue";

const props = defineProps({
  loaded: { type: Boolean, required: false, default: true },
});
</script>

<style lang="scss" scoped>
.card {
  border-radius: 6px;
  background: var(--foreground-white, #fff);
  flex-shrink: 0;
  margin-left: 5px;
  margin-right: 5px;
  margin-bottom: 5px;
  margin-top: 5px;
  padding: 20px;
  display: flex;
  flex-direction: column;

  /* elevation/3 */
  box-shadow: 0px 0px 1px 0px rgba(0, 0, 0, 0.08), 0px 0.5px 2px 0px rgba(0, 0, 0, 0.08),
    0px 4px 8px 0px rgba(0, 0, 0, 0.08);
}
</style>
